import EmojiPicker, {
    EmojiClickData,
    SkinTonePickerLocation,
    Theme
} from "emoji-picker-react";
import { useSelector } from "react-redux";
import { RootState } from "services/redux/store";
import { SVG } from "ui";
import {
    CustomComponentProps,
    GeneralModalProps
} from "utils/types/generalTypes";
import useWindowSize from "utils/hooks/useWindowSize";

export type ChatEmojiModalProps = CustomComponentProps &
    GeneralModalProps & {
        addEmoji: Function;
        left: number;
        top: number;
    };

const ChatEmojiModal = ({
    className,
    style,
    open,
    setOpen,
    left,
    top,
    addEmoji
}: ChatEmojiModalProps) => {
    const mode = useSelector((state: RootState) => state.site.mode);
    const handleSelectEmoji = (emoji: EmojiClickData) => {
        addEmoji(emoji);
    };

    const handleCloseEmoji = () => {
        setOpen(false);
    };

    const [windowWidth] = useWindowSize();
    const makeModalStyle = (): React.CSSProperties => {
        if (windowWidth < 567) {
            return {
                top: `${top}px`
            };
        } else {
            return {
                top: `${top}px`,
                left: `${left}px`
            };
        }
    };

    return (
        <div
            id="emoji-modal"
            className={`modal emoji-modal ${open ? "is-active" : ""} ${className}`}
            style={{ ...style, zIndex: 99999 }}
        >
            <div className="modal-background" onClick={handleCloseEmoji}></div>
            <div className="modal-content" style={makeModalStyle()}>
                <div className="card is-new-content">
                    <div className="p-relative ">
                        <div className="close-wrap">
                            <span
                                className="custom-close-modal"
                                onClick={handleCloseEmoji}
                            >
                                <SVG svg="x" size={16} />
                            </span>
                        </div>
                        <div className="pickerContainer">
                            <EmojiPicker
                                open={true}
                                onEmojiClick={(emoji) => {
                                    handleSelectEmoji(emoji);
                                }}
                                theme={
                                    mode == "light" ? Theme.LIGHT : Theme.DARK
                                }
                                skinTonePickerLocation={
                                    SkinTonePickerLocation.PREVIEW
                                }
                                width={300}
                                height={400}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ChatEmojiModal;
